import CookiePolicy from "../../components/docs/CookiePolicy"

function PoliticaCookies() {
    return (
     
      <CookiePolicy />
     
    )
  }
  
  export default PoliticaCookies
  